export type SDKMethod = 'getUser' | 'reportScore';

export type SDKMessage =
  | { v: 1; kind: 'request'; id: string; method: SDKMethod; args: unknown[] }
  | { v: 1; kind: 'response'; id: string; ok: true; result: unknown }
  | { v: 1; kind: 'response'; id: string; ok: false; error: string }
  | { v: 1; kind: 'event'; name: 'exit' };

export function makeRequest(method: SDKMethod, args: unknown[]): SDKMessage {
  return { v: 1, kind: 'request', id: crypto.randomUUID(), method, args };
}

export function makeOkResponse(id: string, result: unknown): SDKMessage {
  return { v: 1, kind: 'response', id, ok: true, result };
}

export function makeErrorResponse(id: string, error: string): SDKMessage {
  return { v: 1, kind: 'response', id, ok: false, error };
}

export function makeEvent(name: 'exit'): SDKMessage {
  return { v: 1, kind: 'event', name };
}

export function isSDKMessage(value: unknown): value is SDKMessage {
  if (!value || typeof value !== 'object') return false;
  const m = value as Record<string, unknown>;
  if (m['v'] !== 1) return false;
  if (m['kind'] === 'request') {
    return (
      typeof m['id'] === 'string' &&
      (m['method'] === 'getUser' || m['method'] === 'reportScore') &&
      Array.isArray(m['args'])
    );
  }
  if (m['kind'] === 'response') {
    if (typeof m['id'] !== 'string') return false;
    if (m['ok'] === true) return 'result' in m;
    if (m['ok'] === false) return typeof m['error'] === 'string';
    return false;
  }
  if (m['kind'] === 'event') {
    return m['name'] === 'exit';
  }
  return false;
}
